import { useBreadcrumb } from "contexts/breadcrumb/BreadcrumbContext";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ProgramCountTiles from "./ProgramCountTiles";
import ProgramStatisticsChart from "./ProgramStatisticsChart";
import OrderStatisticsChart from "./OrderStatisticsChart";
import TaskStatisticsTiles from "./TaskStatisticsTiles";
import ApplyProgramButton from "./ApplyProgramButton";
import { useTitle } from "hooks/useTitle";

function DashboardView() {
  const { setBreadcrumbs } = useBreadcrumb();
  const { t } = useTranslation("Dashboard");
  useTitle(t("dashboard"));

  useEffect(() => {
    setBreadcrumbs([
      {
        localizationKey: "dashboard",
        path: "/home/dashboard",
        menuItemId: "dashboard",
      },
    ]);
  }, []);

  return (
    <>
      <div className="container-fluid py-4">
        {/* Task Statistics Section */}
        <div className="mb-4">
          <h4 className="mb-3 fw-bold" style={{ color: '#2c3e50' }}>
            {t("taskStatistics")}
          </h4>
          <TaskStatisticsTiles useMyStats={false} />
        </div>

        {/* Program Count Statistics Section */}
        <div className="mb-4">
          <h4 className="mb-3 fw-bold" style={{ color: '#2c3e50' }}>
            {t("programStatisticsOverview")}
          </h4>
          <ProgramCountTiles />
        </div>

        {/* Program & Order Statistics Charts Section */}
        <div className="mb-4">
          <div className="row">
            <div className="col-md-6 mb-4">
              <ProgramStatisticsChart />
            </div>
            <div className="col-md-6 mb-4">
              <OrderStatisticsChart />
            </div>
          </div>
        </div>

        {/* Apply Program Button */}
        <ApplyProgramButton />
      </div>
    </>
  );
}

export default DashboardView;
